// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CardBlur } from 'components';
import FadeInSection from 'components/FadeInSection';

import {
  ButtonWrapper,
  CardsWrapper,
  Grid,
  ImgContainer,
  PageContainer,
  StyledButton,
  TextWrapper,
  WrapperCards,
} from './styles';
import { ReactComponent as FigmaToReact } from 'assets/icons/figma-to-react.svg';
import { ReactComponent as FileFigma } from 'assets/icons/file-figma.svg';
import { ReactComponent as Gauge } from 'assets/icons/gauge.svg';
import { ReactComponent as NavVitesse } from 'assets/icons/vitesse-time.svg';
import { ReactComponent as Waveform } from 'assets/icons/waveform.svg';
import ImageHero from 'assets/images/hero/hero-1.webp';
import HeroMacbook from 'assets/images/hero/hero-macbook.webp';
import ImageHeroMobile from 'assets/images/hero/lacto-blue-1.png';
import HeroMacbookMobile from 'assets/images/hero/macbook-mobile.png';
import FigmaImage from 'assets/images/hero/show-off.png';
import SpeedOfLight from 'assets/images/hero/speed-of-light.png';
import useScreenSize from 'hooks/useScreenSize';
import useScrollTo from 'hooks/useScrollTo';

export const Hero = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.home.views.hero',
  });

  const scrollTo = useScrollTo();
  const screenSize = useScreenSize();
  const navigate = useNavigate();

  const isMobileQuery = () => {
    if (screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  };

  return (
    <PageContainer id={'hero'}>
      <FadeInSection>
        <TextWrapper>
          <div>
            <NavVitesse />
            <p>
              {t('text', { returnObjects: true })[0]}
              <strong>{t('text', { returnObjects: true })[1]}</strong>
            </p>
          </div>
          <ButtonWrapper>
            <StyledButton
              color={'#bfc1f4'}
              onClick={() => {
                scrollTo({
                  to: '#contact',
                  duration: 1200,
                  offset: isMobileQuery() ? 130 : -200,
                });
              }}
            >
              {t('buttons.productDesign')}
            </StyledButton>
            <StyledButton
              color={'#fff'}
              onClick={() => navigate('/brand-identity')}
            >
              {t('buttons.brandIdentity')}
            </StyledButton>
          </ButtonWrapper>
        </TextWrapper>
      </FadeInSection>
      <ImgContainer>
        {isMobileQuery() ? (
          <div>
            <img src={HeroMacbookMobile} alt={'Macbook on top of rocks'} />
          </div>
        ) : (
          <Fragment>
            <Gauge />
            <img src={HeroMacbook} alt={'Macbook on top of rocks'} />
          </Fragment>
        )}
      </ImgContainer>
      <CardsWrapper>
        <Grid>
          <div className={'div1'}>
            {isMobileQuery() ? (
              <img src={ImageHeroMobile} alt={'lacto-blue'} />
            ) : undefined}
            <CardBlur fullWidth>
              <FadeInSection>
                <WrapperCards>
                  <FileFigma />
                  <p>{t('cards.sourceFile.title')}</p>
                  <span>{t('cards.sourceFile.text')}</span>
                </WrapperCards>
              </FadeInSection>
            </CardBlur>
          </div>
          <div className={'div2'}>
            {isMobileQuery() ? (
              <img src={ImageHeroMobile} alt={'lacto-blue'} />
            ) : undefined}
            <CardBlur fullWidth>
              <FadeInSection>
                <WrapperCards>
                  <h3>{t('cards.liveFeedback.title')}</h3>
                  <Waveform />
                  <p>{t('cards.liveFeedback.text')}</p>

                  <StyledButton
                    color={'#bfc1f4'}
                    border
                    onClick={() => {
                      scrollTo({
                        to: '#contact',
                        duration: 1200,
                        offset: isMobileQuery() ? 130 : -200,
                      });
                    }}
                  >
                    Claim
                  </StyledButton>
                </WrapperCards>
              </FadeInSection>
            </CardBlur>
          </div>

          <div className={'div3'}>
            <CardBlur fullWidth>
              <FadeInSection>
                <WrapperCards>
                  <img src={SpeedOfLight} alt={'Speed of light'} />
                </WrapperCards>
              </FadeInSection>
            </CardBlur>
          </div>
          <div className={'div4'}>
            {isMobileQuery() ? (
              <img src={ImageHeroMobile} alt={'lacto-blue'} />
            ) : (
              <Fragment />
            )}
            <CardBlur fullWidth>
              <FadeInSection>
                <WrapperCards>
                  <div>
                    <FigmaToReact />
                    <h3>{t('cards.figmaToCode.title')}</h3>
                    <p>
                      {t('cards.figmaToCode.text', { returnObjects: true })[1]}
                    </p>
                    <p>
                      {t('cards.figmaToCode.text', { returnObjects: true })[0]}
                    </p>

                    <p className='color'>
                      {t('cards.figmaToCode.text', { returnObjects: true })[2]}
                    </p>
                  </div>
                </WrapperCards>
              </FadeInSection>
            </CardBlur>
          </div>
          <div className={'div5'}>
            {isMobileQuery() ? (
              <img src={ImageHeroMobile} alt={'lacto-blue-3'} />
            ) : undefined}
            <CardBlur fullWidth>
              <div>
                <div>
                  <label>{t('cards.tailoredDesign.text')}</label>
                  <h3>
                    <strong>
                      {
                        t('cards.tailoredDesign.title', {
                          returnObjects: true,
                        })[0]
                      }
                    </strong>{' '}
                  </h3>
                </div>
                <FadeInSection>
                  <img
                    style={{ width: '100%' }}
                    src={FigmaImage}
                    alt={'Print'}
                  />
                </FadeInSection>
              </div>
            </CardBlur>
          </div>
        </Grid>
        {isMobileQuery() ? (
          // <img src={ImageHeroMobile} alt={'lacto-blue'} />
          <Fragment />
        ) : (
          <img src={ImageHero} alt={'lacto-blue'} />
        )}
      </CardsWrapper>
    </PageContainer>
  );
};
